import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CheckboxListSecondary from './CheckboxListSecondary';
import ClientProvider from './client';
export default createDemo(import.meta.url, CheckboxListSecondary, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/lists/demos/checkbox-secondary/CheckboxListSecondary.tsx",
    "fileName": "CheckboxListSecondary.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListItemAvatar from '@mui/material/ListItemAvatar';\nimport Checkbox from '@mui/material/Checkbox';\nimport Avatar from '@mui/material/Avatar';\n\nexport default function CheckboxListSecondary() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [checked, setChecked] = React.useState([1]);\n\n  const handleToggle = (value: number) => () => {\n    const currentIndex = checked.indexOf(value);\n    const newChecked = [...checked];\n\n    if (currentIndex === -1) {\n      newChecked.push(value);\n    } else {\n      newChecked.splice(currentIndex, 1);\n    }\n\n    setChecked(newChecked);\n  };\n\n  return (\n    <List dense sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>\n      {[0, 1, 2, 3].map((value) => {\n        const labelId = `checkbox-list-secondary-label-${value}`;\n        return (\n          <ListItem\n            key={value}\n            secondaryAction={\n              <Checkbox\n                edge=\"end\"\n                onChange={handleToggle(value)}\n                checked={checked.includes(value)}\n                slotProps={{ input: { 'aria-labelledby': labelId } }}\n              />\n            }\n            disablePadding\n          >\n            <ListItemButton>\n              <ListItemAvatar>\n                <Avatar\n                  alt={`Avatar n°${value + 1}`}\n                  src={`/static/images/avatar/${value + 1}.jpg`}\n                />\n              </ListItemAvatar>\n              <ListItemText id={labelId} primary={`Line item ${value + 1}`} />\n            </ListItemButton>\n          </ListItem>\n        );\n      })}\n    </List>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 57,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemText from '@mui/material/ListItemText';\nimport ListItemAvatar from '@mui/material/ListItemAvatar';\nimport Checkbox from '@mui/material/Checkbox';\nimport Avatar from '@mui/material/Avatar';\n\nexport default function CheckboxListSecondary() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [checked, setChecked] = React.useState([1]);\n\n  const handleToggle = (value: number) => () => {\n    const currentIndex = checked.indexOf(value);\n    const newChecked = [...checked];\n\n    if (currentIndex === -1) {\n      newChecked.push(value);\n    } else {\n      newChecked.splice(currentIndex, 1);\n    }\n\n    setChecked(newChecked);\n  };\n\n  return (\n    <List dense sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>\n      {[0, 1, 2, 3].map((value) => {\n        const labelId = `checkbox-list-secondary-label-${value}`;\n        return (\n          <ListItem\n            key={value}\n            secondaryAction={\n              <Checkbox\n                edge=\"end\"\n                onChange={handleToggle(value)}\n                checked={checked.includes(value)}\n                slotProps={{ input: { 'aria-labelledby': labelId } }}\n              />\n            }\n            disablePadding\n          >\n            <ListItemButton>\n              <ListItemAvatar>\n                <Avatar\n                  alt={`Avatar n°${value + 1}`}\n                  src={`/static/images/avatar/${value + 1}.jpg`}\n                />\n              </ListItemAvatar>\n              <ListItemText id={labelId} primary={`Line item ${value + 1}`} />\n            </ListItemButton>\n          </ListItem>\n        );\n      })}\n    </List>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 57,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/List",
      "@mui/material/ListItem",
      "@mui/material/ListItemButton",
      "@mui/material/ListItemText",
      "@mui/material/ListItemAvatar",
      "@mui/material/Checkbox",
      "@mui/material/Avatar"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
